module.exports = __webpack_public_path__ + "img/RCloudPrice.0d9bc89e.png";